import { Select } from 'antd';
import styled from 'styled-components';

export const InputSelect = styled(Select)`
  background-color: #ffffff;
  border-radius: 2px;
  color: #828282;
  border: 1px solid #b2bbbf;
  min-width: 0;
  outline: none;
  max-width: ${({ tamanho }) => tamanho || ''};
  &:focus {
    background: #ffffff;
    border: 1px solid #000000;
    color: #000000;
    &:hover {
      background: #ffffff;
      border: 1px solid #000000;
    }
  }
  &:hover {
    background: #ffffff;
    border: 1px solid #b2bbbf;
  }
`;
